import { render } from "./PopupForm.vue?vue&type=template&id=1c925168&scoped=true"
import script from "./PopupForm.vue?vue&type=script&lang=js"
export * from "./PopupForm.vue?vue&type=script&lang=js"

import "./PopupForm.vue?vue&type=style&index=0&id=1c925168&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c925168"]])

export default __exports__